import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=c9d7df9e&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9d7df9e')) {
      api.createRecord('c9d7df9e', component.options)
    } else {
      api.reload('c9d7df9e', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=c9d7df9e&", function () {
      api.rerender('c9d7df9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-215OP8wnjroKb/JS/comp/childrenage.vue"
export default component.exports